import { Heading, Grid, Box } from '@simplywallst/ui-core';

import { useFlag } from '@/features/unleash';

import type { Portfolio } from '@/hooks/usePortfolio';

import { FooterBanner } from './components/FooterBanner';
import { DiversificationAcrossIndustries } from '../DiversificationAcrossIndustries';
import { DiversificationAcrossHoldings } from '../DiversificationAcrossHoldings';
import { DiversificationAcrossGeographicalRegion } from '../DiversificationAcrossGeographicalRegion';

interface Props {
  portfolio: Portfolio;
}

export const AnalysisPanel = ({ portfolio }: Props) => {
  const flag = useFlag({
    name: 'mono-portfolio-diversification-across-holdings',
  });
  const canAccessDiversificationAcrossHoldings =
    flag.flagsReady && flag.enabled;

  return (
    <Grid rowGap="24px">
      <Box
        backgroundColor="noir"
        paddingX="x2"
        paddingY="x3"
        borderRadiusLg="x1"
        paddingLg="x4"
      >
        <Grid rowGap="32px">
          <Heading as="h3" typography="xLargeStrong">
            Diversification
          </Heading>
          <Grid rowGap="32px">
            <Grid rowGap="24px">
              <Heading as="h4" typography="baseStrong">
                Diversification across Industries
              </Heading>
              <DiversificationAcrossIndustries portfolio={portfolio} />
            </Grid>
            {canAccessDiversificationAcrossHoldings && (
              <Grid
                autoRows="max-content"
                templateColumnsMd="1fr 1fr"
                gap="24px"
              >
                <div>
                  <Heading as="h4" typography="baseStrong">
                    Diversification across Holdings
                  </Heading>
                  <DiversificationAcrossHoldings portfolio={portfolio} />
                </div>
                <div>
                  <Heading as="h4" typography="baseStrong">
                    Geographic Exposure
                  </Heading>
                  <DiversificationAcrossGeographicalRegion />
                </div>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Box>
      <FooterBanner />
    </Grid>
  );
};
